export default __webpack_public_path__ + "static/media/32.06491c5f.png";